/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Delivery_3_ValueInputs */

const en_services_delivery_3_value = /** @type {(inputs: Services_Delivery_3_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentation, ownership and support agreed with your team.`)
};

const lv_services_delivery_3_value = /** @type {(inputs: Services_Delivery_3_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumentācija, atbildība un atbalsts saskaņoti ar Jūsu komandu.`)
};

/**
* | output |
* | --- |
* | "Documentation, ownership and support agreed with your team." |
*
* @param {Services_Delivery_3_ValueInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_delivery_3_value = /** @type {((inputs?: Services_Delivery_3_ValueInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Delivery_3_ValueInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_delivery_3_value(inputs)
	return en_services_delivery_3_value(inputs)
});